import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2PaginationModule } from "ng2-pagination";
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';
import { SharedModule } from "../shared/shared.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CustomFormsModule } from "ng2-validation/dist";
import { FormHelperService } from "../core/services/form-helper.service";
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { CreativesService } from './creative.services';
import { CreativeComponent } from './creative.component';
import { CreativeFilterComponent } from './creative-filter.component';
import { CreativeModalComponent } from './creative-modal.component';

@NgModule({
  imports: [CommonModule, SharedModule, FormsModule, Ng2PaginationModule, Ng2DatetimePickerModule, ReactiveFormsModule, CustomFormsModule, Ng2AutoCompleteModule],
  exports: [],
  declarations: [CreativeComponent, CreativeFilterComponent, CreativeModalComponent],
  providers: [CreativesService, FormHelperService],
})
export class CreativeModule { }



// WEBPACK FOOTER //
// ./src/app/creatives/creative.module.ts